export default {
    p: {
        fo: {
            summary: {
                title: 'Features Overview',
                utcNote: 'UTC business-day basis',
                window: 'Window (UTC): {start} ~ {end}',
                windowEnd: 'Up to (UTC): {end}',
                registeredUsers: 'Registered users',
                watchUsers: 'Watch users',
                column: {
                    feature: 'Feature',
                    caliber: 'Participation Basis',
                    participants: 'Participants',
                    denominator: 'Denominator',
                    rate: 'Participation Rate',
                    drilldown: 'Drilldown',
                },
                drilldownAction: 'View Detail',
                rateNull: '—',
                registerPvNote: 'No register-entry PV reported yet',
            },
            denominatorMetric: {
                register_pv: 'Register entry visits',
                registered_users: 'Registered users',
                watch_users: 'Watch users',
            },
            feature: {
                register: 'Register',
                watch: 'Watch',
                report: 'Report',
                not_interested: 'Not Interested',
                publish: 'Publish Content',
                launch: 'Launch Token',
                buy: 'Buy Token',
                sell: 'Sell Token',
            },
            caliber: {
                register: 'All-time newly registered accounts',
                watch: 'All-time watched dramas or videos',
                report: 'All-time submitted reports (excl. not-interested)',
                not_interested: 'All-time marked not-interested',
                publish: 'All-time published content',
                launch: 'All-time launched tokens',
                buy: 'All-time confirmed BUY trades',
                sell: 'All-time confirmed SELL trades',
            },
            detail: {
                title: 'Participant Detail',
                empty: 'Click a feature row above to view participant detail',
                export: 'Export CSV',
                refresh: 'Refresh',
                column: {
                    userId: 'User ID',
                    wallet: 'Wallet Address',
                    times: 'Times',
                    firstAt: 'First Participation',
                    lastAt: 'Last Participation',
                },
                exportSuccess: 'Export task created',
            },
        },
    },
};
